<script>
import FormBasedProviderWidget from "./FormBasedProviderWidget";

export default {
  name: "MPayWidget",
  extends: FormBasedProviderWidget,
}
</script>